import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../components/auth/auth';
import { Card, Badge, Spinner, Row, Col } from 'react-bootstrap';
import './StationDevicesPage.css';

const StationDevicesPage = () => {
    const { serial } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axiosInstance.get(global.config.server_url + 'api/get/station/sensor/status/', {
            params: { serial_number: serial }
        })
        .then(response => {
            setData(response.data);
            setLoading(false);
        })
        .catch(error => {
            console.error('Fetch error:', error);
            setLoading(false);
        });
    }, [serial]);

    if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

    const getSensorBadge = (status) => {
        const isSuccess = status === 'Normal' || status === 'Online';
        const badgeClass = isSuccess ? 'custom-badge-success' : 'custom-badge-danger';
        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };

    const formatLastSent = (timestamp) => {
        if (!timestamp) return <span className="last-sent">No data</span>;
        return new Date(timestamp).toUTCString();
    };

    return (
    <>
        <div className="col-12 col-md-9 mb-2">
             <h4 className= "mb-0"><b>Devices</b></h4>
        </div>
        <div className="container-fluid mt-2">
            <Row className="g-4">
                {/* Station Info - Sticky Left */}
                <Col xs={12} lg={3}>
                    <Card className="h-100 p-3">
                        <h2 className="title">Station</h2>
                        <p>
                          <strong className="sub-title">Serial Number</strong>
                          <span className="serial-num"> {data.serial_number}</span>
                        </p>
                        <p className="sub-title">{data.location}</p>
                        <img
                            src="/images/station.png"
                            alt="Station"
                            className="img-fluid my-3"
                        />
                        <div className="d-flex justify-content-between">
                            <p><strong className="grey">Connection</strong></p>
                            <p>{getSensorBadge(data.station_status)}</p>
                        </div>


                    </Card>
                </Col>

                {/* Modules - Responsive Grid */}
                <Col xs={12} lg={9}>
                    <Row className="g-4">
                        {data.overall_station_data.map((module, idx) => (
                            <Col xs={12} md={6} xl={4} key={idx}>
                                <Card className="h-100 p-3">
                                    <h6 className="module-name">{module.name}</h6>
                                    <div className="d-flex justify-content-between">
                                        <p className="grey">Module</p>
                                        <p className="grey"><strong>{module.module}</strong></p>
                                    </div>
                                    <p className="grey">Sensor</p>
                                    {module.sensors.map((sensor, sIdx) => (
                                        <div key={sIdx} className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="grey">&#8226; {sensor.name}</span>
                                                {getSensorBadge(sensor.status)}
                                            </div>
                                            <small className="last-sent">
                                                Last sent at: {formatLastSent(sensor.last_sent_at)}
                                            </small>
                                        </div>
                                    ))}
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    </>
    );
};

export default StationDevicesPage;
